/*
 * audit-log (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { auditLogs } from "./audit-logs.schema"

/* Select */
export type AuditLog = z.infer<typeof selectAuditLogSchema>
export const selectAuditLogSchema = createSelectSchema(auditLogs)

/* Filters */
export type AuditLogFilters = z.infer<typeof auditLogFiltersSchema>
export const auditLogFiltersSchema = z.object({ userId: z.string() })

/* Create */
export const createAuditLogSchema = createInsertSchema(auditLogs)
export type CreateAuditLog = z.infer<typeof createAuditLogSchema>

/* Update */
export const updateAuditLogSchema = createInsertSchema(auditLogs)
	.partial()
	.required({ id: true })
export type UpdateAuditLog = z.infer<typeof updateAuditLogSchema>

/* Delete */
export const deleteAuditLogSchema = createInsertSchema(auditLogs).required({
	id: true,
})
export type DeleteAuditLog = z.infer<typeof deleteAuditLogSchema>
